import * as React from 'react';
import { SVGProps } from 'react';

const SvgToolsAndResources = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m6.06 11.9-2.54-1.27m16.53 8.31-2.54-1.28M9.77 8.7 8.88 6m5.81 17.57-.89-2.7M5.7 16.8l-2.7.89m17.57-5.81-2.7.89m-8.96 7.74-1.28 2.54m8.31-16.54-1.27 2.54M11.8 21.19a6.4 6.4 0 1 0 0-12.8 6.4 6.4 0 0 0 0 12.8Z"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M11.8 17.29a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm22.49-6.98v1.9a3.15 3.15 0 1 1-6.3 0v-1.9"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M27.99 12.2v-1.9a3.15 3.15 0 1 1 6.3 0v1.9m-8.6 10.22v-1.57a5.45 5.45 0 1 1 10.9 0v1.57h-10.9Z"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.25}
      d="M19.62 31.12h15.62"
    />
    <path
      fill="currentColor"
      d="M36.66 32.37H35l-1.17-1.25L35 29.87h1.66v2.5Z"
    />
    <path fill={props.fill} d="M22.33 28.62v4.98l-13.54.02-5.01-5h18.55Z" />
  </svg>
);

export default SvgToolsAndResources;
